import { render, staticRenderFns } from "./_man.vue?vue&type=template&id=12e666bc&scoped=true&"
import script from "./_man.vue?vue&type=script&lang=js&"
export * from "./_man.vue?vue&type=script&lang=js&"
import style0 from "./_man.vue?vue&type=style&index=0&id=12e666bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e666bc",
  null
  
)

export default component.exports